export const moduleRunStatusData = {
    edgeDetails: {
        "fgs-dom":{
            status: 'success',
            timeStamp: "14-Aug 01:17 AM",
            url: "https://www.google.co.in/"
        },
        "fgs-do":{
            status: 'success',
            timeStamp: "14-Aug 01:17 AM",
            url: "https://www.google.co.in/"
        },
        "dom-do":{
            status: 'success',
            timeStamp: "14-Aug 01:17 AM",
            url: "https://www.google.co.in/"
        },
        "do-rdp":{
            status: 'success',
            timeStamp: "14-Aug 01:17 AM",
            url: "https://www.google.co.in/"
        },
        "rdp-cp":{
            status: 'delayed',
            timeStamp: "14-Aug 01:17 AM",
            url: "https://www.google.co.in/"
        },
        "rdp-ff":{
            status: 'success',
            timeStamp: "14-Aug 01:17 AM",
            url: "https://www.google.co.in/"
        },
        "poos-do":{
            status: 'success',
            timeStamp: "14-Aug 01:17 AM",
            url: "https://www.google.co.in/"
        }
    },
    moduleDetails: {
        "fgs": {
            moduleDisplayName: "FG Salvage", 
            lastRunCompletedTime: "14 Aug 2024, 01:17 AM ET",
            lastRunStartTime: "13 Aug 2024, 09:30 PM ET",
            status: "Complete",
            sourcePosition: "right",
            targetPosition: "",
            url: "https://www.google.co.in/"
        },
        "dom": {
            moduleDisplayName: "DOM", 
            lastRunCompletedTime: "14 Aug 2024, 01:17 AM ET",
            lastRunStartTime: "13 Aug 2024, 09:30 PM ET",
            status: "Complete",
            sourcePosition: "bottom",
            targetPosition: "left",
            url: "https://www.google.co.in/"
        },
        "do": {
            moduleDisplayName: "Deployment Optimization", 
            lastRunCompletedTime: "14 Aug 2024, 01:17 AM ET",
            lastRunStartTime: "13 Aug 2024, 09:30 PM ET",
            status: "Running",
            sourcePosition: "",
            targetPosition: "",
            url: "https://www.google.co.in/"
        },
        "rdp": {
            moduleDisplayName: "RDP", 
            lastRunCompletedTime: "14 Aug 2024, 01:17 AM ET",
            lastRunStartTime: "13 Aug 2024, 09:30 PM ET",
            status: "Complete",
            sourcePosition: "right",
            targetPosition: "left",
            url: "https://www.google.co.in/",
        },
        "cp": {
            moduleDisplayName: "Capacity Planning", 
            lastRunCompletedTime: "14 Aug 2024, 01:17 AM ET",
            lastRunStartTime: "13 Aug 2024, 09:30 PM ET",
            status: "Running",
            sourcePosition: "",
            targetPosition: "left",
            url: "https://www.google.co.in/"
        },
        "ff": {
            moduleDisplayName: "Freight Forecasting", 
            lastRunCompletedTime: "14 Aug 2024, 01:17 AM ET",
            lastRunStartTime: "13 Aug 2024, 09:30 PM ET",
            status: "Complete",
            sourcePosition: "",
            targetPosition: "left",
            url: "https://www.google.co.in/"
        },
        "poos": {
            moduleDisplayName: "POOS", 
            lastRunCompletedTime: "14 Aug 2024, 01:17 AM ET",
            lastRunStartTime: "13 Aug 2024, 09:30 PM ET",
            status: "Complete",
            sourcePosition: "right",
            targetPosition: "",
            url: "https://www.google.co.in/"
        },
    
    }

};

const getSourcePosition = (module) => {
  if(module === 'fgs') {
    return 'right';
  } else if (module === 'dom') {
    return 'bottom';
  }
  else if (module === 'do') {
    return '';
  }
  else if (module === 'rdp') {
    return 'right';
  }
  else if (module === 'cp') {
    return 'bottom';
  }
  else if (module === 'ff') {
    return '';
  }
  else if (module === 'poos') {
    return 'right';
  }
  else if (module === 'slp') {
    return 'right';
  }
};
const getTargetPosition = (module) => {
  if(module === 'fgs') {
    return 'left';
  } else if (module === 'dom') {
    return 'left';
  }
  else if (module === 'do') {
    return '';
  }
  else if (module === 'rdp') {
    return 'left';
  }
  else if (module === 'cp') {
    return 'left';
  }
  else if (module === 'ff') {
    return 'left';
  }
  else if (module === 'poos') {
    return '';
  }
  else if (module === 'slp') {
    return 'left';
  }
  else if (module === 'iof') {
    return 'left';
  }
  else if (module === 'erm') {
    return 'bottom';
  }
  else if (module === 'nps') {
    return 'left';
  }
};

export const transformApiDataToModuleStatus = (apiData) => {
  const defaultEdgeDetails = {
    "fgs-dom": {},
    "fgs-do": {},
    "dom-do": {},
    "do-rdp": {},
    "rdp-cp": {},
    "rdp-ff": {},
    "poos-do": {},
    "poos-slp": {},
    "slp-iof": {},
    "rr-fgs": {},
    "poos-erm": {},
    "cp-nps": {},
    "cp-do": {}
  };

  const defaultModuleDetails = {
    "fgs": {},
    "dom": {},
    "do": {},
    "rdp": {},
    "cp": {},
    "ff": {},
    "poos": {},
    "slp": {},
    "iof": {},
    "rr": {},
    "nps": {},
    "erm": {}
  };

  const edgeDetails = {};
  const moduleDetails = {};

  // Flatten and filter out nulls
  const flatData = apiData.flat().filter(Boolean);

  // Map run data by module code
  const moduleMap = {};
  flatData.forEach(run => {
    const code = run.code?.toLowerCase();
    if (code) {
      moduleMap[code] = run;
    }
  });

  // Populate edge details
  Object.keys(defaultEdgeDetails).forEach(edge => {
    const [source, target] = edge.split('-');
    const sourceRun = moduleMap[source];
    const targetRun = moduleMap[target];

    const status = sourceRun && targetRun
      ? targetRun.result === 'SUCCESS' ? 'success' : 'delayed'
      : 'NA';

    edgeDetails[edge] = {
      status,
      timeStamp: targetRun?.start_time || 'N/A',
      url: targetRun?.run_page_url || '#'
    };
  });

  // Populate module details
  Object.keys(defaultModuleDetails).forEach(module => {
    const run = moduleMap[module];
    console.log("modules>>>>>>>>>>>>>>>>>", module, run?.run_name );
    moduleDetails[module] = {
      moduleDisplayName: run?.run_name  || module.toUpperCase(),
      lastRunCompletedTime: run?.end_time || 'N/A',
      lastRunStartTime: run?.start_time || 'N/A',
      status: run?.result || 'N/A',
      sourcePosition: getSourcePosition(module), // these can be filled manually
      targetPosition: getTargetPosition(module),
      url: run?.run_page_url || '#'
    };
  });

  return {
    edgeDetails,
    moduleDetails
  };
};